import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
`;

export const Title = styled.span`
  display: inline-block;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  color: #5933aa;
`;
